import Home from "./components/Home/Home";
import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Preloader";
import Navbar from "./components/NavBar";
import Footer from "./components/Footer";
import Resume from "./components/Resume/Resume";
import AboutMe from "./components/AboutMe/AboutMe";
import Projects from "./components/Projects/Projects";
import Blogs from "./components/Blogs/Blogs";
import { Analytics } from "@vercel/analytics/react";
// import Splash from "./components/Splash";
import ScrollToTop from "./components/ScrollToTop";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import "./App.css";
import "./style.css";
import EduExp from "./components/EduExp/EduExp";
function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);
  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Analytics />
        <Navbar />
        <ScrollToTop />
        <Routes>
          {/* <Route path="/" exact render={(props) => <Splash {...props} />} /> */}
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/AboutMe" element={<AboutMe />} />
          <Route path="/EduExp" element={<EduExp />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
